import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Child } from '@isophi/pap-api';
import {RouterLinkFactory} from "../../../core/router/router-link.factory";

@Component({
    selector: 'app-child-selector',
    templateUrl: './child-selector.component.html',
    styleUrls: ['./child-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChildSelectorComponent {
  @Input() children: Child[];

  @Input() selectedChild: Child;

  public constructor(public links: RouterLinkFactory) {}
}
